import { render, staticRenderFns } from "./barclose.vue?vue&type=template&id=7a088a9a&"
import script from "./barclose.vue?vue&type=script&lang=js&"
export * from "./barclose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports